module.exports = __webpack_public_path__ + "img/pen.f55d1254.png";